<div class="main-screen-container">
    <div class="top-row">
        <h3 class="w-100">SMTP</h3>
        <div class="d-flex flex-row gap-3">
            <mat-form-field appearance="outline">
                <mat-label style="color: gray;">Szukaj...</mat-label>
                <input matInput [formControl]="filter" (keyup)="doFilter($event)">
            </mat-form-field>
        </div>
        <div class="d-flex flex-row gap-3 flex-fill justify-content-end h-100">
             <button *ngIf="0" mat-flat-button class="btn-action" color="accent"
                (click)="router.navigate(['rekbot-add'])"><img style="width:25px;" src="/assets/img/add-rekbot.png" alt="">
                Dodaj Rekbota</button>
            <button mat-flat-button class="big-button" color="accent" (click)="fetchSmtpConfig()">
                <mat-icon class="big-icon m-0">refresh</mat-icon>
            </button>
        </div>
       
    </div>
                
                <table mat-table matSort [dataSource]="dataSource" class="common-table">

                    <!--- Note that these columns can be defined in any order.
                          The actual rendered columns are set as a property on the row definition" -->

                    <!-- serial_no Column -->
                    <ng-container matColumnDef="host">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> HOST </th>
                        <td mat-cell *matCellDef="let element"> {{element.host}} </td>
                    </ng-container>

                    <!-- IP Column -->
                    <ng-container matColumnDef="port">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> PORT </th>
                        <td mat-cell *matCellDef="let element"> {{element.port}} </td>
                    </ng-container>

                    <!-- IP Column -->
                    <ng-container matColumnDef="start_tls_enable">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> START TLS ENABLE </th>
                        <td mat-cell *matCellDef="let element"> {{element.start_tls_enable}} </td>
                    </ng-container>


                    <!-- Symbol Column -->
                    <ng-container matColumnDef="auth">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>AUTH </th>
                        <td mat-cell *matCellDef="let element"> {{element.auth}} </td>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="username">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>NAZWA UŻYTKOWNIKA</th>
                        <td mat-cell *matCellDef="let element"> {{element.username}} </td>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="password">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>HASŁO</th>
                        <td mat-cell *matCellDef="let element"> {{element.password}} </td>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="account_type">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>TYP</th>
                        <td mat-cell *matCellDef="let element"> {{element.type}} </td>
                    </ng-container>

                    <!-- Symbol Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef> </th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-cell">
                                <button type="button" class="btn btn-primary btn-action"
                                    (click)="openModal(editModal, element)"><mat-icon aria-hidden="false"
                                        aria-label="Edytuj" fontIcon="edit"></mat-icon></button>
                                <button type="button" class="btn btn-danger btn-action"
                                    (click)="deleteElement(element)"><mat-icon aria-hidden="false" aria-label="Usuń"
                                        fontIcon="delete"></mat-icon></button>
                            </div>
                            
                        </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <br>
                <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons aria-label="Wybierz stronę">
                </mat-paginator>


            </div>


<div *ngIf="0" class="row">
    <div style="margin-bottom: 10px;display:flex;justify-content: flex-center;">
    </div>
    <div style="margin-bottom: 10px;display:flex;justify-content: flex-end;">
        <button *ngIf="0" mat-flat-button class="btn-action" color="accent"
            (click)="openModal(editModal, createSMTP())">+ DODAJ KONTO SMTP</button>

    </div>
</div>




<!-- app-settings-smtp-table *ngIf="accounts.length" [accounts]="accounts"></app-settings-smtp-table -->

<ng-template #editModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Edycja konta</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="editForm">
            <input type="hidden" id="id" name="id" formControlName="id">

            <div class="form-group">
                <label for="host">Host</label>
                <div class="input-group">
                    <input id="host" name="host" class="form-control" placeholder="" formControlName="host">
                </div>
            </div>
            <div class="form-group">
                <label for="port">Port</label>
                <div class="input-group">
                    <input id="port" name="port" class="form-control" placeholder="" formControlName="port">
                </div>
            </div>
            <div class="form-group">
                <label for="type">Start TLS</label>
                <div class="input-group">
                    <mat-button-toggle-group (change)="toggledTLS()" formControlName="start_tls_enable" selected="1"
                        style="width:100%">
                        <mat-button-toggle *ngFor="let op of TLSState" [value]="op.value"
                            (click)="selectedTLSState = op.value" style="width:50%">
                            {{ op.name }}
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>
            <div class="form-group">
                <label for="type">Auth</label>
                <div class="input-group">
                    <mat-button-toggle-group (change)="toggledAuth()" selected="1" style="width:100%"
                        [formControl]="selectedAuthStateForm">
                        <mat-button-toggle *ngFor="let op of AuthState" [value]="op.value" style="width:50%">
                            {{ op.name }}
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>
            <div class="form-group">
                <label for="username">Użytkownik</label>
                <div class="input-group">
                    <input id="username" name="username" class="form-control" placeholder="" formControlName="username">
                </div>
            </div>
            <div class="form-group">
                <label for="password">Hasło</label>
                <div class="input-group">
                    <input id="password" name="password" class="form-control" placeholder="" formControlName="password">
                </div>
            </div>
            <div class="form-group">
                <label for="type">Typ</label>
                <div class="input-group">
                    <mat-button-toggle-group (change)="toggledAccountType()" formControlName="type" style="width:100%"
                        [formControl]="selectedTypeForm">
                        <mat-button-toggle *ngFor="let op of AccountTypes" [value]="op.value" style="width:50%">
                            {{ op.name }}
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="modal.close('Save click');">Anuluj</button>
        <button type="button" class="btn btn-outline-dark"
            (click)="onSumbitSmtp();modal.close('Save click');">Zapisz</button>
    </div>
</ng-template>

<ng-template #showModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Account settings show</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="editForm">
            <input type="hidden" id="id" name="id" formControlName="id">
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="modal.close('Save click');">Anuluj</button>
    </div>
</ng-template>

<ng-template #settingsModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Ustawienia SMTP</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <!-- app-rekbot-settings></app-rekbot-settings>-->
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="modal.close('Close click');">Zamknij</button>
    </div>
</ng-template>